import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { customAuthAxios } from '@/utils/customAuthAxios';
import { useErrorToast } from '../toast/useErrorToast';


const apiUrlLogin = `${process.env.REACT_APP_API_URL}authen/jwt/create/`;
const baseUrl = process.env.REACT_APP_RESERVE_BASE_URL;
const externalAuthUrl = `${baseUrl}`; // 仮のURL、先方の仕様に合わせて調整


const fetchReserveApiToken = async () => {
  try {
    const res = await customAuthAxios.post('/blocks_reserve/table-request/token/');
    const token = res.data.access_token;
    sessionStorage.setItem('tableRequestApiKey', token);
    // console.log(token);
  } catch (error) {
    console.error('Blocks Reserve APIトークンの取得に失敗しました', error);
  }
};

export const useLoginRestaurant = () => {
  const navigate = useNavigate();
  const showErrorToast = useErrorToast();

  const onSubmit = async (data: any) => {
    try {
      const authRes = await axios.post(apiUrlLogin, data, { headers: { 'Content-Type': 'application/json' } });
      const token = authRes.data.access;
      localStorage.clear();
      localStorage.setItem('localJWT', token);
      const restaurantRes = await customAuthAxios.get(`accounts/restaurants/me/`);

      //Bespo Tokenの取得
      await fetchReserveApiToken();

      // first_view_urlがある場合はそれを使用、ない場合はダッシュボードに遷移
      const restaurantId = restaurantRes.data.id;
      const firstViewUrl = restaurantRes.data.first_view_url;
      
      if (firstViewUrl) {
        // first_view_urlがある場合はそのURLを使用
        navigate(`/restaurants/${restaurantId}${firstViewUrl}`);
      } else {
        // first_view_urlがない場合はダッシュボードに遷移
        navigate(`/restaurants/${restaurantId}/dashboard`);
      }
    } catch (error: any) {
      if (error.response?.status === 401 || error.response?.status === 404) {
        showErrorToast("ユーザーネームまたはパスワードが誤っています。");
      } else {
        showErrorToast("予期せぬエラーが発生しました。");
      }
    }
  };
  return onSubmit;
};